import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae5e441a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "flex gap-4" }
const _hoisted_3 = { class: "modal-icon warning" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "modal-heading" }, " Oops! You haven’t selected any properties for this widget. "),
  /*#__PURE__*/_createElementVNode("p", { class: "modal-content mt-1" }, " This means the “Specials” feature will be turned off. Do you want to continue? ")
], -1))
const _hoisted_5 = { class: "flex gap-4 self-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WarningIcon = _resolveComponent("WarningIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "overlay",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_WarningIcon)
        ]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "btn-secondary is-btn-size-default min-w-[100px]",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm')))
        }, " Yes "),
        _createElementVNode("button", {
          class: "btn-primary is-btn-size-default min-w-[100px]",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel')))
        }, " No ")
      ])
    ])
  ], 64))
}